import { render, staticRenderFns } from "./ControlDrugDetail.vue?vue&type=template&id=494c978a&scoped=true"
import script from "./ControlDrugDetail.vue?vue&type=script&lang=js"
export * from "./ControlDrugDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c978a",
  null
  
)

export default component.exports